import { create } from 'zustand'

const useSignatureCaptureStore = create((set, get) => ({
  capturedSignature: null,
  activeSlotIndex: null,
  signatureImages: {},

  setCapturedSignature: (dataUrl) => {
    const { activeSlotIndex, signatureImages } = get()

    if (activeSlotIndex !== null) {
      const updatedImages = { ...signatureImages, [activeSlotIndex]: dataUrl }
      set({
        capturedSignature: dataUrl,
        signatureImages: updatedImages,
        activeSlotIndex: null,
      })
    } else {
      set({ capturedSignature: dataUrl })
    }
  },
  clearCapturedSignature: () => {
    set({ capturedSignature: null })
  },
  setActiveSlotIndex: (index) => {
    set({ activeSlotIndex: index })
  },
  resetSignatures: () => {
    set({ capturedSignature: null, activeSlotIndex: null, signatureImages: {} })
  },
}))

export default useSignatureCaptureStore
